import { ErrorBoundary } from 'react-error-boundary';

import Text from '~/components/Text';

type ComponentErrorBoundaryProps = {
  children: React.ReactNode;
  fallbackRender?: (props: { error: Error }) => React.ReactNode;
};

export function DefaultErrorBoundaryFallback({ error }: { error: Error }) {
  return (
    <div className="flex flex-col max-w-2xl py-8 space-y-2">
      <Text as="p" type="body" size="md" className="leading-tight tracking-normal text-center">
        {error.message.split('Error: ')[1]}
      </Text>
    </div>
  );
}

export function ComponentErrorBoundary({ children, fallbackRender }: ComponentErrorBoundaryProps) {
  function defaultFallbackRender({ error }: { error: Error }) {
    return <DefaultErrorBoundaryFallback error={error} />;
  }

  return <ErrorBoundary fallbackRender={fallbackRender ?? defaultFallbackRender}>{children}</ErrorBoundary>;
}
